<template>

  <div  v-if="$can('read','candidates')">

    <!--<candidate-edit
      :job-id="jobId"
    />-->

    <!-- Filters -->
    <!---<candidates-list-filters
      :role-filter.sync="roleFilter"
      :plan-filter.sync="planFilter"
      :status-filter.sync="statusFilter"
      :role-options="roleOptions"
      :plan-options="planOptions"
      :status-options="statusOptions"
    />-->

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >
    <div >
      <!-- Using modifiers -->
    
      <!-- Element to collapse -->
      <div id="advance-filter" v-if="advanceFilter && $can('read','mass_mailer')" >
        <b-card >
          <b-row style="margin-right: auto; padding: 15px;">
            <small v-if="error" class="text-danger">{{ error }}</small>
            <b-col md="4" xl="4" xs="4" class="mb-1">
              <b-form-group
                label="Search other fields"
                label-for="search-query">
                <b-form-input
                  v-model="query"
                  placeholder="Search by candidate id, fname, lname, contact, email, curr_company, position, skill"
                  type="text"
                  ref="search"
                />
              </b-form-group>
            </b-col>
            <b-col md="5" xl="5" xs="5" class="mb-1">
              <b-form-group
                label="Skills"
                label-for="skills">
                <v-select
                  v-model="skillSelected"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="title"
                  :options="skillOptions"
                  ref="skills"
                  :close-on-select="false"
                  multiple
                  :reduce="(option) => option.title"
                />
              </b-form-group>
            </b-col>
            <b-col md="3" xl="3" xs="3" class="mb-1">
              <b-form-group
                label="Source"
                label-for="source">
                <v-select
                  v-model="sourceSelected"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="title"
                  :options="sourceOptions"
                  ref="source"
                  :reduce="(option) => option.title"
                />
              </b-form-group>
            </b-col>
            <b-col md="6" xl="6" xs="6" class="mb-1">
              <b-form-group
                label="Location"
                label-for="location">
                <v-select
                  v-model="locationSelected"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="title"
                  :options="citiesOptions"
                  ref="city"
                  :close-on-select="false"
                  multiple
                  :reduce="(option) => option.title"
                />
              </b-form-group>
            </b-col>
            <b-col md="2" xl="2" xs="2" class="mb-1">
              <b-form-group
                label="Qualification"
                label-for="qualification">
                <v-select
                  v-model="qualificationSelected"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="title"
                  :options="qualificationOptions"
                  ref="qualification"
                  :reduce="(option) => option.title"
                />
              </b-form-group>
            </b-col>
            <b-col md="2" xl="2" xs="2" class="mb-1">
              <b-form-group
                label="Gender"
                label-for="gender">
                <v-select
                  v-model="genderSelected"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="title"
                  :options="genderOptions"
                  ref="gender"
                  :reduce="(option) => option.title"
                />
              </b-form-group>
            </b-col>
            <b-col md="2" xl="2" xs="2" class="mb-1">
              <b-form-group
                label="Status"
                label-for="status">
                <v-select
                  v-model="statusSelected"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="title"
                  :options="statusOptions"
                  ref="gender"
                  multiple
                  :reduce="(option) => option.title"
                />
              </b-form-group>
            </b-col>
            <b-col md="2" xl="2" xs="2" class="mb-1">
              <b-form-group
                label="Exclude Keywords"
                label-for="exclude-search">
                <b-form-input
                  v-model="exclude"
                  placeholder="Exclude company"
                  type="text"
                  ref="exclude-search"
                />
              </b-form-group>
            </b-col>
            <b-col
                md="2"
                xl="2"
                xs="2"
                class="mb-1"
              >
                <b-form-group
                  label="Annual Salary"
                  label-for="ctc"
                >
                  
                    <b-form-input
                      id="min-ctc"
                      v-model="minCTC"
                      type="number"
                      step=".01"
                      ref="minctc"
                      placeholder="Min Salary in Lacs"
                    />
                    to
                    <b-form-input
                      id="max-ctc"
                      v-model="maxCTC"
                      type="number"
                      step=".01"
                      ref="maxctc"
                      placeholder="Max Salary in lacs"
                    />
                 
                </b-form-group>
              </b-col>
              <b-col
                md="2"
                xl="2"
                xs="2"
                class="mb-1"
              >
                <b-form-group
                  label="Experience"
                  label-for="exp"
                >
                  
                    <b-form-input
                      id="minExp"
                      v-model="minExp"
                      type="number"
                      step=".01"
                      ref="minexp"
                      placeholder="Min Exp"
                    />
                    to
                    <b-form-input
                      id="maxExp"
                      v-model="maxExp"
                      type="number"
                      step=".01"
                      ref="maxexp"
                      placeholder="Max Exp"
                    />
                 
                </b-form-group>
              </b-col>
              <b-col
                md="2"
                xl="2"
                xs="2"
                class="mb-1"
              >
                <b-form-group
                  label="Notice Period"
                  label-for="notice-period"
                >
                  
                    <b-form-input
                      id="min-np"
                      v-model="minNoticePeriod"
                      type="number"
                      step=".01"
                      ref="minnp"
                      placeholder="Min in days"
                    />
                    to
                    <b-form-input
                      id="max-np"
                      v-model="maxNoticePeriod"
                      type="number"
                      step=".01"
                      ref="maxnp"
                      placeholder="Max in days"
                    />
                 
                </b-form-group>
              </b-col>
            <!-- <b-col md="2" xl="2" xs="6" class="mb-1">
              <b-form-group
                label="Search other fields"
                label-for="search-query">
                <b-form-input
                  v-model="query"
                  placeholder="Search by position name, recruiter, poc and many more ..."
                  type="text"
                  ref="skill"
                />
              </b-form-group>
            </b-col> -->
            <b-col md="3" xl="3" xs="3" class="mb-1">
              <b-form-group
                label=""
                label-for=""
                class="text-center"
                style="width: -webkit-fill-available;">
                <b-button variant="primary" value="submit" id="submit" type="submit" style="margin-top: 20px; width: -webkit-fill-available;" @click="getAdvancedFilteredCandidates">Filter</b-button>  
              </b-form-group>
              <!-- <a @click="clearFilter">Clear Filter</a>   -->
            </b-col>
            <b-col md="3" xl="3" xs="3" class="mb-1">
              <b-form-group
                label=""
                label-for=""
                class="text-center">
                <b-button variant="outline-secondary"  width="100%" style="margin-top: 20px; width: -webkit-fill-available;" @click="clearFilter">Clear Filter</b-button>  
              </b-form-group>
              <!-- <a @click="clearFilter">Clear Filter</a>   -->
            </b-col>
          </b-row>
        </b-card>
      </div>
    </div>

      <div class="m-2">
        
        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="5"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            
          >
            <label>Show </label>
            <v-select v-if="fetchCandidates.length > 0"
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="pageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>of <b>{{ totalCandidates }}</b> entries</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="4"
            lg="4"
            xl="4"
            sm="4"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="filter"
                id="filter-input"
                class="d-inline-block mr-1"
                placeholder="Search..."
                trim
              />
            </div>
          </b-col>
          <b-col
            
            md="1"
            lg="1"
            xl="1"
            sm="1"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-button
                class="d-inline-block mr-1"
                variant="outline-primary" value="submit" id="submit"
                @click="simpleFilterCandidates"
              > Search</b-button>
            </div>
          </b-col>
          <b-col
            
            md="2"
            lg="2"
            xl="2"
            sm="2"
            v-if="$can('read','mass_mailer')"
          >
          <b-button class="d-inline-block mr-1"
                variant="outline-primary" value="submit"  id="submit" @click="advanceFilterShow"> <feather-icon icon="Filter"/>Advance Filter</b-button>
          </b-col>
        </b-row>
        <b-row  class="mt-2">
          <b-col
            md="3"
            lg="3"
            xl="3"
            sm="3" v-if="$can('read','mass_mailer') & fetchCandidates.length > 0">
            <b-button
                class="d-inline-block mr-1"
                variant="outline-primary" 
                @click="selectAllRows()"
              > Select All</b-button>
          </b-col>
          <b-col
            v-if="selected.length > 0"
            md="3"
            lg="3"
            xl="3"
            sm="3">
            <b-button
                class="d-inline-block mr-1"
                variant="outline-primary" 
                @click="clearSelected()"
              > Clear Selected</b-button>
          </b-col>
          <b-col 
            v-if="selected.length > 0 && $can('manage','bulk_assign')"
            md="3"
            lg="3"
            xl="3"
            sm="3">
            <b-button
                class="d-inline-block mr-1"
                variant="outline-primary" 
                @click="multiAssignToJob()"
              > Bulk Assign</b-button>
          </b-col>
          <b-col
            v-if="selected.length > 0 && $can('read','mass_mailer')"
            md="3"
            lg="3"
            xl="3"
            sm="3">
            <b-button
                class="d-inline-block mr-1"
                variant="outline-primary"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'" 
                @click="showConfirmBox()"
              > Send Mass Mail</b-button>
              <!-- @click="sendMassMailer()" -->
          </b-col>
        </b-row>

      </div>
      <!-- <b-table
        ref="refCandidateListTable"
        class="position-relative"
        :items="fetchCandidates"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        :filter="filter"
        :filter-included-fields="['first_name', 'last_name', 'email', 'candidate_id', 'contact_no', 'curr_location']"
        :current-page="currentPage"
        :per-page="perPage"
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
        @filtered="onFiltered"
      > -->
      <b-table
        ref="selectableTable"
        class="position-relative"
        :items="fetchCandidates"
        :current-page="currentPage"
        :per-page="perPage"
        :total-rows="totalRows"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
        select-mode="multi"
        selectable
        @row-selected="onRowSelected"
        v-if="fetchCandidates.length > 0"
      >
        <template #cell(id)="{ rowSelected }">
          <template v-if="rowSelected">
          <span aria-hidden="true">&check;</span>
          <span class="sr-only">Selected</span>
        </template>
        <template v-else>
          <span aria-hidden="true">&nbsp;</span>
          <span class="sr-only">Not selected</span>
        </template>
        </template>
        <!-- Column: Candidate -->
        <template #cell(first_name)="data">
          <b-media vertical-align="center" v-if="$can('read','candidates')">
            
            <b-link
              :to="{ name: 'apps-candidates-view', params: { id: data.item.id, jobId: jobId }, query: jobId ? { assign: '1' } : {} }"
              class="font-weight-bold d-block text-nowrap"
            >
              {{ data.item.first_name }} {{data.item.last_name}}<br>
              {{ data.item.candidate_id }}
            </b-link>
            
          </b-media>
        </template>

        <!-- Column: Contact -->
        <template #cell(email)="data">
          <div class="text-nowrap">
            
            <span class="align-text-top">{{ data.item.email }}</span><br>
            <span class="align-text-top">{{ data.item.contact_no }}</span>
          </div>
        </template>

        <!-- Column: Location -->
        <template #cell(curr_location)="data">
          <div class="text-nowrap">
            {{ data.item.curr_location }}
          </div>
        </template>
        <!-- Column: Location -->
        <template #cell(source)="data">
          <div class="text-nowrap">
            <!--<span class="align-text-top text-capitalize" v-if="data.item.jobs[0]">{{ JSON.parse(data.item.jobs[0].candidate_jobs.addedBy)[0].title }}</span>-->
            <span class="align-text-top text-capitalize" >{{ JSON.parse(data.item.created_by)[0].title }}</span><br>
            <!--<span class="align-text-top text-capitalize" v-if="data.item.jobs[0]">{{ data.item.jobs[0].candidate_jobs.source }}</span>-->
            <span class="align-text-top text-capitalize" >{{ data.item.source }}</span><br>
            <!-- <span class="align-text-top text-capitalize" >{{ data.item.createdAt }}</span> -->
          </div>
        </template>
         <!-- Column: Status -->
        <template #cell(status)="data">
          <div class="text-nowrap">
            <!--<span class="align-text-top text-capitalize" v-if="data.item.jobs[0]">{{ JSON.parse(data.item.jobs[0].candidate_jobs.addedBy)[0].title }}</span>-->
            <!--<span class="align-text-top text-capitalize" v-if="data.item.jobs[0]">{{ data.item.jobs[0].candidate_jobs.source }}</span>-->
            <span class="align-text-top text-capitalize" >{{ data.item.skills }}</span>
          </div>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item :to="{ name: 'apps-candidates-edit', params: { id: data.item.id, jobId: 'null' } }" v-if="$can('edit','candidates')">
              <feather-icon icon="EditIcon"/>
              <span class="align-middle ml-50">Edit Profile</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="$can('edit','candidates') && isInActionCandidate(data.item)"
              @click.prevent="openUpdateResume(data.item)"
            >
              <feather-icon icon="UploadIcon"/>
              <span class="align-middle ml-50">Update Resume</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-else-if="$can('edit','candidates')"
              @click.prevent="startResumeUpload(data.item)"
            >
              <feather-icon icon="UploadIcon"/>
              <span class="align-middle ml-50">Upload Resume</span>
            </b-dropdown-item>
            

            <b-dropdown-item v-if="all.includes('true') && $can('read','bulk_assign')" @click="assignJob(data.item.id, data.item.candidate_id, data.item.source, 'S')" >
              <feather-icon icon="EditIcon"/>
              <span class="align-middle ml-50">Assign to this Job</span>
            </b-dropdown-item>
            
          </b-dropdown>
        </template>
      </b-table>
      <div
        v-if="searchPerformed && fetchCandidates.length === 0"
        class="text-center py-4"
      >
        <feather-icon icon="UserXIcon" size="40" class="text-muted mb-1" />
        <p class="text-muted mb-25">No candidates found</p>
        <small class="text-muted">
          The candidate you searched for is not in the database.
          <b-link @click="$router.push({ name: 'apps-candidates-add' })">Add a new candidate</b-link>
          or try a different search.
        </small>
      </div>
      <b-row v-if="fetchCandidates.length > 0">
        <b-col sm="5" md="6" class="my-1">
        <b-form-group
          label="Per page"
          label-for="per-page-select"
          label-cols-sm="6"
          label-cols-md="4"
          label-cols-lg="3"
          label-align-sm="right"
          label-size="sm"
          class="mb-0"
        >
          <b-form-select
            id="per-page-select"
            v-model="perPage"
            :options="pageOptions"
            size="sm"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col
          cols="12"
          
        >
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="center"
          size="sm"
          class="my-0"
        />
      </b-col>
    </b-row>           
    </b-card>
    <input
      ref="resumeFileInput"
      type="file"
      class="d-none"
      :accept="resumeAccept"
      @change="onResumeFileSelected"
    >
    <update-resume-modal
      :visible.sync="resumeModalVisible"
      :candidate="resumeUploadCandidate"
      :uploading="resumeUploading"
      @submit="submitResumeUpdate"
    />
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination, BCollapse, BCardBody, VBToggle, BFormGroup,BFormSelect
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import CandidateEdit from './../candidates-edit/CandidateEdit.vue'
import CandidateListAddNew from './CandidateListAddNew.vue'
//import { toRefs, toRef } from 'vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import JobService from '@/services/job-service'
import CandidateService from '@/services/candidate-service'
import jobTimelineService from '@/services/job-timeline'
import UserService from '@/services/user-service'
import { sendPushToUserId, buildCandidateDeepLink } from '@/utils/fcm-push'
import emailTemplates from "@/services/email-templates";
import mailService from "@/services/mail-service"
import massMailerService from "@/services/massMailer-service"
import adminConfigService from "@/services/admin-config-service";
import uploadResumeMixin from '@/mixins/uploadResumeMixin'
import UpdateResumeModal from '@/views/apps/candidate/components/UpdateResumeModal.vue'

//import { DynamicScroller } from 'vue-virtual-scroller'

export default {
  mixins: [uploadResumeMixin],
  data() {
    return {
      jobId: this.jobId,
      all: this.all,
      positionName: this.positionName,
      accMgr: this.accMgr,
      client: this.client,
      attachments: this.attachments,
      locations: this.locations,
      amId : '',
      fetchCandidates: [],
      tableColumns : [
      { key: 'id', sortable: false, Label: '' },    
    { key: 'first_name', sortable: true, Label: 'Title' },     
    //{ key: 'first_name', sortable: true },
    { key: 'email', sortable: true, label: 'Contact' },
    //{ key: 'contact_no', label: 'Contact', sortable: true },
    {
      key: 'curr_location',
      label: 'Location',
      formatter: true,
      sortable: true,
    },
    {
      key: 'source',
      label: 'Sourced',
      formatter: true,
      sortable: true,
    },
    { key: 'skills', label: 'Skills', sortable: true },
    { key: 'actions' },
  ],
  statusSelected: '',
  statusOption: [
    {value: 'Uploaded', text: 'Uploaded'},
    {value: 'Initiated', text: 'Initiated'},
    {value: 'Review Reject', text: 'ReviewReject'},
    {value: 'Profile Shared', text: 'ProfileShared'},
    {value: 'Screen Reject', text: 'ScreenReject'},
    {value: 'Screen Select', text: 'ScreenSelect'},
    {value: 'Inprocess', text: 'Inprocess'},
    {value: 'OnHold', text: 'OnHold'},
    {value: 'Shortlisted', text: 'Shortlisted'},
    {value: 'Offered', text: 'Offered'},
    {value: 'Not Offered', text: 'NotOffered'},
    {value: 'Joined', text: 'Joined'},
    {value: 'Offer Drop', text: 'OfferDrop'},
    {value: 'Rejected', text: 'Rejected'},
  ],
  //tableColumns: ['id', 'first_name', 'last_name', 'contact_no', 'email', 'curr_location', 'source', 'status', 'actions' ],
  //const jobId: '')
  //totalCandidates: 0,
  totalRows: 0,
  currentPage: 1,
  perPage: 50,
  pageOptions: [5, 10, 25, 50, 100],
  totalCandidates: 0,
  searchQuery: '',
  sortBy: 'id',
  isSortDirDesc: true,
  from: 0,
  to: 0,
  of: 0,
  isAddNewCandidateSidebarActive: false,
  filter: null,
  filterOn: [],
  query: '',
  exclude: '',
  minCTC: '',
  maxCTC: '',
  minExp: '',
  maxExp: '',
  error: '',
  minNoticePeriod: '',
  maxNoticePeriod: '',
  skillSelected: '',
  sourceSelected: '',
  locationSelected: '',
  qualificationSelected: '',
  genderSelected: '',
  selected: [],
  advanceFilter: false,
  searchPerformed: false,
  rowSelected: false,
  skillOptions: [],
  mail: '',
  sourceOptions: [
        { title: "Naukri" },
        { title: "Monster" },
        { title: "LinkedIn" },
        { title: "Indeed" },
        { title: "Shine" },
        { title: "TimesJobs" },
        { title: "IIMJobs" },
        { title: "Glassdoor" },
        { title: "FreshersWorld" },
        { title: "Other" },
        { title: "Train N Hire" },
        { title: "Internal" },
        { title: "Referenced" },
      ],
  citiesOptions: [{"title":"Mumbai"},{"title":"Delhi"},{"title":"Bangalore"},{"title":"Hyderabad"},{"title":"Pune"},{"title":"Ahmedabad"},{"title":"Chennai"},{"title":"Kolkata"},{"title":"Surat"},{"title":"Jaipur"},{"title":"Lucknow"},{"title":"Kanpur"},{"title":"Nagpur"},{"title":"Indore"},{"title":"Thane"},{"title":"Bhopal"},{"title":"Visakhapatnam"},{"title":"Pimpri and Chinchwad"},{"title":"Patna"},{"title":"Vadodara"},{"title":"Ghaziabad"},{"title":"Ludhiana"},{"title":"Agra"},{"title":"Nashik"},{"title":"Faridabad"},{"title":"Meerut"},{"title":"Rajkot"},{"title":"Kalyan and Dombivali"},{"title":"Vasai Virar"},{"title":"Varanasi"},{"title":"Srinagar"},{"title":"Aurangabad"},{"title":"Dhanbad"},{"title":"Amritsar"},{"title":"Navi Mumbai"},{"title":"Allahabad"},{"title":"Haora"},{"title":"Ranchi"},{"title":"Gwalior"},{"title":"Jabalpur"},{"title":"Coimbatore"},{"title":"Vijayawada"},{"title":"Jodhpur"},{"title":"Madurai"},{"title":"Raipur"},{"title":"Kota"},{"title":"Chandigarh"},{"title":"Guwahati"},{"title":"Solapur"},{"title":"Hubli and Dharwad"},{"title":"Bareilly"},{"title":"Mysore"},{"title":"Moradabad"},{"title":"Gurgaon"},{"title":"Aligarh"},{"title":"Jalandhar"},{"title":"Tiruchirappalli"},{"title":"Bhubaneswar"},{"title":"Salem"},{"title":"Mira and Bhayander"},{"title":"Thiruvananthapuram"},{"title":"Bhiwandi"},{"title":"Saharanpur"},{"title":"Gorakhpur"},{"title":"Guntur"},{"title":"Amravati"},{"title":"Bikaner"},{"title":"Noida"},{"title":"Jamshedpur"},{"title":"Bhilai Nagar"},{"title":"Warangal"},{"title":"Cuttack"},{"title":"Firozabad"},{"title":"Kochi"},{"title":"Bhavnagar"},{"title":"Dehradun"},{"title":"Durgapur"},{"title":"Asansol"},{"title":"Nanded Waghala"},{"title":"Kolapur"},{"title":"Ajmer"},{"title":"Gulbarga"},{"title":"Loni"},{"title":"Ujjain"},{"title":"Siliguri"},{"title":"Ulhasnagar"},{"title":"Jhansi"},{"title":"Sangli Miraj Kupwad"},{"title":"Jammu"},{"title":"Nellore"},{"title":"Mangalore"},{"title":"Belgaum"},{"title":"Jamnagar"},{"title":"Tirunelveli"},{"title":"Malegaon"},{"title":"Gaya"},{"title":"Ambattur"},{"title":"Jalgaon"},{"title":"Udaipur"},{"title":"Maheshtala"},{"title":"Tiruppur"},{"title":"Davanagere"},{"title":"Kozhikode"},{"title":"Kurnool"},{"title":"Akola"},{"title":"Rajpur Sonarpur"},{"title":"Bokaro Steel"},{"title":"Bellary"},{"title":"Patiala"},{"title":"South Dum Dum"},{"title":"Rajarhat Gopalpur"},{"title":"Bhagalpur"},{"title":"Agartala"},{"title":"Muzaffarnagar"},{"title":"Bhatpara"},{"title":"Latur"},{"title":"Panihati"},{"title":"Dhule"},{"title":"Rohtak"},{"title":"Korba"},{"title":"Bhilwara"},{"title":"Brahmapur Town"},{"title":"Muzaffarpur"},{"title":"Ahmadnagar"},{"title":"Mathura"},{"title":"Kollam"},{"title":"Avadi"},{"title":"Kadapa"},{"title":"Rajahmundry"},{"title":"Bilaspur"},{"title":"Kamarhati"},{"title":"Shahjahanpur"},{"title":"Bijapur"},{"title":"Rampur"},{"title":"Shimoga"},{"title":"Chandrapur"},{"title":"Junagadh"},{"title":"Thrissur"},{"title":"Alwar"},{"title":"Barddhaman"},{"title":"Kulti"},{"title":"Kakinada"},{"title":"Nizamabad"},{"title":"Parbhani"},{"title":"Tumkur"},{"title":"Hisar"},{"title":"Ozhukarai"},{"title":"Biharsharif"},{"title":"Darbhanga"},{"title":"Panipat"},{"title":"Aizawl"},{"title":"Bally"},{"title":"Dewas"},{"title":"Tirupati"},{"title":"Ichalkaranji"},{"title":"Karnal"},{"title":"Bathinda"},{"title":"Jalna"},{"title":"Kirari Suleman Nagar"},{"title":"Purnia"},{"title":"Satna"},{"title":"Maunath Bhanjan"},{"title":"Barasat"},{"title":"Sonipat"},{"title":"Farrukhabad and Fatehgarh"},{"title":"Sagar"},{"title":"Raurkela"},{"title":"Durg"},{"title":"Imphal"},{"title":"Ratlam"},{"title":"Hapur"},{"title":"Arrah"},{"title":"Karimnagar"},{"title":"Anantapur"},{"title":"NDMC"},{"title":"Etawah"},{"title":"Ambernath"},{"title":"Bharatpur"},{"title":"Begusarai"},{"title":"Tiruvottiyur"},{"title":"North Dum Dum"},{"title":"Gandhidham"},{"title":"Baranagar"},{"title":"Puducherry"},{"title":"Thoothukkudi"},{"title":"Sikar"},{"title":"Rewa"},{"title":"Mirzapur and Vindhyachal"},{"title":"Raichur"},{"title":"Pali"},{"title":"Ramagundam"},{"title":"Hardwar"},{"title":"Vizianagaram"},{"title":"Katihar"},{"title":"Nagercoil"},{"title":"Ganganagar"},{"title":"Karawal Nagar"},{"title":"Mango"},{"title":"Thanjavur"},{"title":"Bulandshahr"},{"title":"Uluberia"},{"title":"Murwara"},{"title":"Sambhal"},{"title":"Singrauli"},{"title":"Nadiad"},{"title":"Secunderabad"},{"title":"Naihati"},{"title":"Yamunanagar"},{"title":"Bidhan Nagar"},{"title":"Pallavaram"},{"title":"Bidar"},{"title":"Munger"},{"title":"Panchkula"},{"title":"Burhanpur"},{"title":"Raurkela Industrial Township"},{"title":"Kharagpur"},{"title":"Dindigul"},{"title":"Hospet"},{"title":"Gandhinagar"},{"title":"Nangloi Jat"},{"title":"English Bazar"},{"title":"Ongole"},{"title":"Eluru"},{"title":"Deoghar"},{"title":"Chapra"},{"title":"Haldia"},{"title":"Khandwa"},{"title":"Puri Town"},{"title":"Nandyal"},{"title":"Morena"},{"title":"Amroha"},{"title":"Anand"},{"title":"Bhind"},{"title":"Bhalswa Jahangir Pur"},{"title":"Madhyamgram"},{"title":"Bhiwani"},{"title":"Navi Mumbai Panvel Raigad"},{"title":"Baharampur"},{"title":"Ambala"},{"title":"Morvi"},{"title":"Fatehpur"},{"title":"Rae Bareli"},{"title":"Khora"},{"title":"Bhusawal"},{"title":"Orai"},{"title":"Bahraich"},{"title":"Vellore"},{"title":"Mahesana"},{"title":"Khammam"},{"title":"Sambalpur"},{"title":"Raiganj"},{"title":"Sirsa"},{"title":"Dinapur Nizamat"},{"title":"Serampore"},{"title":"Sultan Pur Majra"},{"title":"Guna"},{"title":"Jaunpur"},{"title":"Panvel"},{"title":"Shivpuri"},{"title":"Surendranagar Dudhrej"},{"title":"Unnao"},{"title":"Hugli and Chinsurah"},{"title":"Sitapur"},{"title":"Hastsal"},{"title":"Tambaram"},{"title":"Adityapur"},{"title":"Badalapur"},{"title":"Alappuzha"},{"title":"Cuddalore"},{"title":"Silchar"},{"title":"Gadag and Betigeri"},{"title":"Bahadurgarh"},{"title":"Machilipatnam"},{"title":"Shimla"},{"title":"Medinipur"},{"title":"Deoli"},{"title":"Bharuch"},{"title":"Hoshiarpur"},{"title":"Jind"},{"title":"Chandannagar"},{"title":"Adoni"},{"title":"Tonk"},{"title":"Faizabad"},{"title":"Tenali"},{"title":"Alandur"},{"title":"Kancheepuram"},{"title":"Vapi"},{"title":"Rajnandgaon"},{"title":"Proddatur"},{"title":"Navsari"},{"title":"Budaun"},{"title":"Uttarpara Kotrung"},{"title":"Mahbubnagar"},{"title":"Erode"},{"title":"Batala"},
      {"title":"Saharsa"},{"title":"Haldwani and Kathgodam"},{"title":"Vidisha"},{"title":"Thanesar"},{"title":"Kishangarh"},{"title":"Dallo Pura"},{"title":"Veraval"},{"title":"Banda"},{"title":"Chittoor"},{"title":"Krishnanagar"},{"title":"Barrackpur"},{"title":"Lakhimpur"},{"title":"Santipur"},{"title":"Porbandar"},{"title":"Hindupur"},{"title":"Balurghat"},{"title":"Bhadravati"},{"title":"Hanumangarh"},{"title":"Moga"},{"title":"Pathankot"},{"title":"Hajipur"},{"title":"Sasaram"},{"title":"Habra"},{"title":"Bid"},{"title":"Mohali"},{"title":"Burari"},{"title":"Beawar"},{"title":"Abohar"},{"title":"Tiruvannamalai"},{"title":"Jamuria"},{"title":"Kaithal"},{"title":"Godhra"},{"title":"Bhuj"},{"title":"Robertson Pet"},{"title":"Shillong"},{"title":"Rewari"},{"title":"Hazaribag"},{"title":"Bhimavaram"},{"title":"Mandsaur"},{"title":"Chas"},{"title":"Rudrapur"},{"title":"Chitradurga"},{"title":"Kumbakonam"},{"title":"Dibrugarh"},{"title":"Kolar"},{"title":"Chhindwara"},{"title":"Bankura"},{"title":"Mandya"},{"title":"Dehri"},{"title":"Raigarh"},{"title":"Madanapalle"},{"title":"Nalgonda"},{"title":"Hathras"},{"title":"Malerkotla"},{"title":"Siwan"},{"title":"Chhattarpur"},{"title":"Hassan"},{"title":"Lalitpur"},{"title":"Gondiya"},{"title":"North Barrackpur"},{"title":"Bettiah"},{"title":"Palakkad"},{"title":"Rajapalayam"},{"title":"Botad"},{"title":"Modinagar"},{"title":"Deoria"},{"title":"Raniganj"},{"title":"Palwal"},{"title":"Khanna"},{"title":"Neemuch"},{"title":"Pilibhit"},{"title":"Mustafabad"},{"title":"Hardoi"},{"title":"Guntakal"},{"title":"Pithampur"},{"title":"Motihari"},{"title":"Dhaulpur"},{"title":"Srikakulam"},{"title":"Nabadwip"},{"title":"Patan"},{"title":"Jagdalpur"},{"title":"Udupi"},{"title":"Basirhat"},{"title":"Damoh"},{"title":"Halisahar"},{"title":"Jagadhri"},{"title":"Rishra"},{"title":"Kurichi"},{"title":"Dimapur"},{"title":"Palanpur"},{"title":"Dharmavaram"},{"title":"Gokal Pur"},{"title":"Kashipur"},{"title":"Ashokenagar Kalyangarh"},{"title":"Baidyabati"},{"title":"Sawai Madhopur"},{"title":"Puruliya"},{"title":"Mandoli"},{"title":"Mainpuri"},{"title":"Kanchrapara"},{"title":"Satara"},{"title":"Churu"},{"title":"Madavaram"},{"title":"Gangapur"},{"title":"Dabgram"},{"title":"Darjiling"},{"title":"Barshi"},{"title":"Etah"},{"title":"Jhunjhunun"},{"title":"Chikmagalur"},{"title":"Jetpur Navagadh"},{"title":"Roorkee"},{"title":"Gudivada"},{"title":"Baleshwar"},{"title":"Baran"},{"title":"Hoshangabad"},{"title":"Nagaon"},{"title":"Pudukkottai"},{"title":"Adilabad"},{"title":"Hosur"},{"title":"Muktsar"},{"title":"Yavatmal"},{"title":"Titagarh"},{"title":"Barnala"},{"title":"Chittaurgarh"},{"title":"Narasaraopet"},{"title":"Dum Dum"},{"title":"Basti"},{"title":"Valsad"},{"title":"Ambur"},{"title":"Giridih"},{"title":"Chandausi"},{"title":"Gonda"},{"title":"Bally Town"},{"title":"Kalol"},{"title":"Bagaha"},{"title":"Ambikapur"},{"title":"Achalpur"},{"title":"Gondal"},{"title":"Bagalkot"},{"title":"Osmanabad"},{"title":"Akbarpur"},{"title":"Champdani"},{"title":"Deesa"},{"title":"Khurja"},{"title":"Nandurbar"},{"title":"Azamgarh"},{"title":"Ghazipur"},{"title":"Delhi Cantonment"},{"title":"Firozpur"},{"title":"Baripada"},{"title":"Mughalsarai"},{"title":"Anantnag"},{"title":"Sehore"},{"title":"Bongaon"},{"title":"Kanpur Cantonment"},{"title":"Khardaha"},{"title":"Tadpatri"},{"title":"Port Blair"},{"title":"Sultanpur"},{"title":"Bhadrak"},{"title":"Shikohabad"},{"title":"Jalpaiguri"},{"title":"Shamli"},{"title":"Karaikkudi"},{"title":"Khargone"},{"title":"Wardha"},{"title":"Ranibennur"},{"title":"Kishanganj"},{"title":"Neyveli"},{"title":"Amreli"},{"title":"Suryapet"},{"title":"Gangawati"},{"title":"Hindaun"},{"title":"Jamalpur"},{"title":"Bhiwadi"},{"title":"Ballia"},{"title":"Bansberia"},{"title":"Tadepalligudem"},{"title":"Miryalaguda"},{"title":"Baraut"},{"title":"Udgir"},{"title":"Betul"},{"title":"Bundi"},{"title":"Jehanabad"},{"title":"Ambala Sadar"},{"title":"Nagapattinam"},{"title":"Nagaur"},{"title":"Buxar"},{"title":"Seoni"},{"title":"Greater Noida"},{"title":"Hinganghat"},{"title":"Sujangarh"},{"title":"Bhadreswar"},{"title":"Chilakaluripet"},{"title":"Kasganj"},{"title":"Kalyani"},{"title":"Gangtok"},{"title":"Datia"},{"title":"Nagda"},{"title":"Banswara"},{"title":"Kapurthala"}, {"title": "Ratnagiri"}, {"title": "Goa"}, {"title": "Panaji"}],
  qualificationOptions: [],
  genderOptions: [
        { title: "Male" },
        { title: "Female" },
        { title: "Transgender" },
        { title: "Non-binary/non-conforming" },
        { title: "Prefer not to respond" },
      ],
      bulkMailData: '',
      massMailList: [],
      candidate_id: 0,
      statusOptions: [
            { value: "All", title: "All" },
            { value: "UploadedBySourcer", title: "UploadedBySourcer" },
            { value: "UploadedByRecruiter", title: "UploadedByRecruiter" },
            { value: "AssignedByMassMail", title: "AssignedByMassMail" },
            { value: "Wrong Number", title: "Wrong Number" },
            { value: "Not Answered", title: "Not Answered" },
            { value: "Not Reachable", title: "Not Reachable" },
            { value: "Not Interested", title: "Not Interested" },
            { value: "Not Relevant", title: "Not Relevant" },
            { value: "Call Back", title: "Call Back" },
            { value: "ProfileShared", title: "ProfileShared" },
            { value: "ReviewReject", title: "ReviewReject" },
            { value: "Initiated", title: "Initiated" },
            { value: "Screen Reject", title: "ScreenReject" },
            { value: "Screen Select", title: "ScreenSelect" },
            { value: "Duplicate", title: "Duplicate" },
            { value: "Inprocess", title: "Inprocess" },
            { value: "OnHold", title: "OnHold" },
            { value: "Shortlisted", title: "Shortlisted" },
            { value: "Offered", title: "Offered" },
            { value: "Not Offered", title: "NotOffered" },
            { value: "Joined", title: "Joined" },
            { value: "Offer Drop", title: "OfferDrop" },
            { value: "Rejected", title: "Rejected" },
            { value: "Early Attrition", title: "Early Attrition" },
            { value: "Attrition", title: "Attrition" },
            { value: "Confirmed", title: "Confirmed" },
            { value: "LOI Issued", title: "LOI Issued" },
            { value: "Document Submitted", title: "Document Submitted" },
            { value: "Drop", title: "Drop" },
        ],
    }
  },
  
  components: {
    UpdateResumeModal,
    CandidateListAddNew,
    CandidateEdit,
    VBToggle,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BCollapse,
    vSelect,
    BCardBody,
    BFormGroup,
    BFormSelect
    //DynamicScroller
  },
  props: {
    jobId:  Number,
    all: String,
    positionName: String,
    accMgr: String,
    locations: String,
    client: String,
    attachments: String
  },
  created() {
    if(this.jobId && this.all == "false") {
      this.getCandidates(this.jobId)
    } else if (this.jobId && this.all == "true") {
      this.getAllCandidates()
    }

    JobService.getJobPositionList().then(res => {
      console.log(res.data)
      this.skillOptions = res.data
    })
    UserService.getAllUsersDd().then( res => {
      if(res.status === "OK") {
        console.log("in if")
        //this.recruiters = res.data.filter(item => item.role === "talent-advisor-sourcer" || item.role === "account-manager" || item.role === "talent-advisor");
        this.programMgr = res.data.filter(item => item.role === "program-manager");
        this.accountMgr = res.data.filter(item => item.role === "account-manager");

        //this.sourcer = res.data.filter(item => item.role === "talent-advisor-sourcer" || item.role === "account-manager");
        this.amId = this.accountMgr.filter(item => item.title === this.accMgr)  
        //console.log(this.recruiters)
        console.log(this.accountMgr)
        //console.log(this.sourcer)
      }
    })
    //this.dataMeta = computed(() => {
    // const localItemsCount = this.fetchCandidates ? this.fetchCandidates.length : 0;
    // //return {
    //   this.from = this.perPage.value * (this.currentPage.value - 1) + (localItemsCount ? 1 : 0);
    //   this.to = this.perPage.value * (this.currentPage.value - 1) + localItemsCount;
    //   this.of = this.fetchCandidates.length;
    //}
  //})
  },
  methods: {
    getCandidates() {
      console.log(this.jobId)
      JobService.getCandidatesByJob(this.jobId).then(res => {
        console.log("job can",res.data)
        if(res.status === "OK") {
          this.fetchCandidates = res.data
          this.currentPage = 1
          this.totalRows = res.totalCount
          this.totalCandidates = res.totalCount
        } else {
          console.log("Failed")
        }
      })
    },
    getAllCandidates() {
      CandidateService.getAllCandidatesData().then(res => {
        console.log(res.data)
        if(res.status === "OK") {
          
          //this.fetchCandidates = res.data.filter(item => (item.jobs.length < 1 || !item.jobs[0].job_id.endsWith(this.jobId)) /*&& ( item.jobs.length ? item.jobs[0].status !== 'Active' : item.jobs.length < 1)*/)
          this.fetchCandidates = res.data
          this.currentPage = 1
          console.log("in if", res.status,this.fetchCandidates )
          this.totalRows = res.totalCount
          this.totalCandidates = res.totalCount
          
        } else {
          console.log("Failed")
        }
      })
    },
    
    resolveCandidateStatusVariant(status) {
      //console.log("called")
      //const resolveCandidateStatusVariant = status => {
      if (status === 'Uploaded') return 'badge-secondary'
      if (status === 'Initiated') return 'badge-warning'
      if (status === 'ReviewReject') return 'badge-danger'
      if (status === 'ProfileShared') return 'badge-info'
      if (status === 'ScreenReject') return 'badge-danger'
      if (status === 'ScreenSelect') return 'badge-info'
      if (status === 'Inprocess') return 'badge-info'
      if (status === 'On-Hold') return 'badge-warning'
      if (status === 'Shortlisted') return 'badge-success'
      if (status === 'Offered') return 'badge-success'
      if (status === 'NotOffered') return 'badge-danger'
      if (status === 'Joined') return 'badge-success'
      if (status === 'OfferDrop') return 'badge-danger'
      if (status === 'Rejected') return 'badge-danger'
      return 'badge-secondary'
  //}
    },
    assignJob(id, can_id, source, count) {
      const jid = this.jobId
      const cid = parseInt(id)
      const c = [];
      let canSource = source
      
      c.push(cid)
       
      const userData = JSON.parse(localStorage.getItem("userData"));
      const user = `[{"title" : "${userData.first_name} ${userData.last_name}", "emp_id": "${userData.emp_id}"}]`;
      const username = `${userData.first_name} ${userData.last_name}`
      const userRole = JSON.parse(localStorage.getItem('userData')).roles[0]
      const candidate = this.fetchCandidates.filter(item => item.id === parseInt(id))
      console.log(candidate)
      let sourcer = JSON.parse(candidate[0].created_by)[0].emp_id // JSON.parse(data.item.created_by)[0].title
      let status = candidate[0].status
      const createdAt = candidate[0].createdAt 
      if ( userRole === 'TALENT-ADVISOR') {
        status = 'UploadedByRecruiter'
      }  
        //console.log('in first if', candidate)
      // } else if ( status === 'UploadedBySourcer' || status === 'Uploaded') 
      else {
        status = 'UploadedBySourcer'
        //console.log('in third if',candidate)
      } 
      //console.log('type of', typeof createdAt)

      const now = new Date();
      const diff = this.numDaysBetween(now, new Date(createdAt))
      console.log('diff',diff)
      
      if(diff > 5 ) {
        canSource = 'ATS'
        console.log('source diff greater',canSource, diff, createdAt)
      } else {
        canSource = source
        console.log('source diff less',canSource, diff, createdAt)
      }
      if(diff > 30 ) {
        sourcer = 'ATS'
        console.log('source diff greater',canSource, diff, createdAt)
      } else {
        sourcer = sourcer
        console.log('source diff less',canSource, diff, createdAt)
      }
      
      const data = {
        job_id: this.jobId,
        candidate_id: c,
        candidateStatus: status,
        source: canSource,
        addedBy: user,
        updatedBy: user,
        sourcer: sourcer,
        //recruiter: userData.emp_id
      }
      console.log('assign to job ', data)
      JobService.assignCandidateToJob(data).then(res => {
        
        if(res.status === "OK") {
          console.log('Assign to Job', can_id, id, data, res)
          const timelineData = {
            title: `Candidate Id - ${can_id} - Assigned to the job with Status ${data.candidateStatus}`,
            description: `CS-Changed`, /// CS-Changed means candidate status changed
            type: "success",
            createdBy: username,
            jobId: this.jobId,
            candidate_id: cid,
            candidateStatus: data.candidateStatus
            
          }
          
          jobTimelineService.create(timelineData).then(res => {
            //console.log("timeline", res)
            if( userRole === 'TALENT-ADVISOR' ) {
              //const candidate = this.fetchCandidates.filter(item => item.candidate_id === can_id )
              // JobService.getJob(this.jobId).then((res) => {
              //   const a = res.data.account_mgr.slice(1,-1)
              //   const position_name = res.data.position_name
              //   const acc_mgr = JSON.parse('[' + a + ']')[0].id
              
              const position_name = this.positionName
              const acc_mgr = this.amId[0].id

              sendPushToUserId(acc_mgr, {
                title: `New Candidate Added By ${username} - ${position_name}`,
                body: 'Your approval is required',
                link: buildCandidateDeepLink(cid, this.jobId),
                data: {
                  module: 'candidates',
                  type: 'candidate_added',
                  candidateId: String(cid),
                  jobId: String(this.jobId),
                },
              }).catch(() => {})

              //})
            }
          })

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Candidate Added to the Job Successfully',
              icon: 'EditIcon',
              variant: 'success',
              timeout: 5000,
            },
          })
          if(count === 'S') {
            this.$emit('refreshParent', true)
          }
        } else if (res.status === 410 || res.message === 'Candidate already exist in Current Job') {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Failed! Candidate already exist in Job !!!',
              icon: 'EditIcon',
              variant: 'danger',
              timeout: 5000,
            },
          })
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Candidate Add to Job Failed !!!',
              icon: 'EditIcon',
              variant: 'danger',
              timeout: 5000,
            },
          })
        }
      })
    },
    simpleFilterCandidates() {
      console.log(this.filter)
      CandidateService.getSimpleFilteredCandidates(this.filter.toLowerCase()).then( res => {
        console.log(res)
        if(res.status === "OK") {
          this.fetchCandidates = res.data
          this.currentPage = 1
          this.totalRows = res.totalCount
          this.totalCandidates = res.totalCount
        }
        this.searchPerformed = true
      })
    },
    advanceFilterShow() {
      this.advanceFilter = !this.advanceFilter
    },
    getAdvancedFilteredCandidates() {
      console.log(this.skillSelected, this.locationSelected, this.statusSelected)
      const data = {
        query: this.query.trim().toLowerCase(),
        skill: this.skillSelected ? this.skillSelected.join(',').toLowerCase() : '',
        gender: this.genderSelected ? this.genderSelected.trim() : '',
        qualification: this.qualificationSelected ? this.qualificationSelected.trim() : '',
        location: this.locationSelected ? this.locationSelected.join(', ').trim() : '',
        source: this.sourceSelected ? this.sourceSelected.trim() : '',
        status: this.statusSelected ? this.statusSelected : '',
        exclude: this.exclude.trim().toLowerCase(),
        minctc: this.minCTC,
        maxctc: this.maxCTC,
        minexp: this.minExp,
        maxexp: this.maxExp,
        minnp: this.minNoticePeriod,
        maxnp: this.maxNoticePeriod
      }
      console.log(data)
      CandidateService.getMatchingCandidates(data).then(res => {
        //this.$router.push({ path: '/apps/view-job/' + this.jobId })
        console.log(res)
        if (res.status === "OK") {
          this.error = ''
          this.fetchCandidates = res.data
          this.currentPage = 1
          this.totalRows = res.totalCount
          this.totalCandidates = res.totalCount
        } else if (res.status === 502) {
          //this.loading = false
            this.error = 'Aargh!! looks like something is not right, Please wait for 1 minute and try clicking add again.'
        } else if ((res.status === 401 ) || (res.status === 403 )) {
            
            window.sessionStorage.setItem('lastPage', window.location.href.split('/#')[1])
            this.error = 'Seesion Expired. Please Login again'
            localStorage.clear();
            this.$router.push({ name: "auth-login" });
        } else {
            this.error = res
        }
        this.searchPerformed = true
      })
    },
    clearFilter() {
      this.$router.push({ path: '/apps/view-job/' + this.jobId })
      this.query = ''
      this.exclude = ''
      this.minCTC = ''
      this.maxCTC = ''
      this.minExp = ''
      this.maxExp = ''
      this.error = ''
      this.minNoticePeriod = ''
      this.maxNoticePeriod = ''
      this.skillSelected = ''
      this.sourceSelected = ''
      this.locationSelected = ''
      this.qualificationSelected = ''
      this.genderSelected = ''
      this.getAllCandidates()
    },
    // onRowSelected(id) {
    //     let exist = false
    //     if(this.selected.length > 0) {
    //       exist = this.selected.find(
    //         function(i) {
    //           return i == id;
    //         }
    //       );
    //     }
    //     if(!exist) {
    //       this.selected.push(id)
    //     } else if (exist) {
    //       this.selected = this.selected.filter(item => item !== id)
    //     }
        
    //     console.log(this.selected)
    // },
    onRowSelected(items) {
      const rowsSelected = items.map(({id}) => ({id}))
      this.selected = []
      for(var i in rowsSelected)
        this.selected.push(rowsSelected[i].id);
        //this.selected = [...new Set(this.selected)];
      console.log(this.selected)
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows()
      console.log(this.selected)
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected()
      console.log(this.selected)
    },
    selectAll() {
      //data.map(({id, deviceName}) => ({id, deviceName})
      let data = this.fetchCandidates.slice(0,50)
      let selectedData = data.map(({id}) => ({id}))
      for(var i in selectedData)
        this.selected.push(selectedData[i].id);
      console.log(this.selected)  
    },
    showConfirmBox() {
      this.boxOne = ''
      this.$bvModal
        .msgBoxConfirm('Are you sure?', {
          cancelVariant: 'outline-secondary',
        })
        .then(value => {
          const response = value
          console.log('confirm response', response)
          if(response) {
            this.sendMassMailer()
          }

        })
    },
    sendMassMailer() {
      const userData = JSON.parse(localStorage.getItem("userData"));
      const user = `[{"title" : "${userData.first_name} ${userData.last_name}", "emp_id": "${userData.emp_id}"}]`;
      const username = `${userData.first_name} ${userData.last_name}`
      const useremail = `${userData.email}`
      const usercontact = `${userData.contact_no}`
      const sender_id = `${userData.emp_id}`
      const mailer_id = Date.now()
      let mailList = []
      let i = 0;
      for ( i = 0; i < this.selected.length; i++) {
          console.log('value of i',i)
          
          const candidate = this.fetchCandidates.filter(item => item.id === this.selected[i])
          const am_data = this.accountMgr.filter(item => item.title === this.accMgr)
          const am_email = am_data[0].email
          // const pm_email = (this.programMgr.filter(item => item.emp_id === am_data[0].mgr_id))[0].email
          this.candidate_id =  candidate[0].id
          const mailData = {
            position_name : this.positionName,
            client : this.client,
            location : this.locations,
            jd_file : this.attachments,
            rec_name : username,
            rec_email : useremail,
            rec_contact : usercontact,
            am_email : am_email ,
            can_fname : candidate[0].first_name,
            can_lname : candidate[0].last_name,
            can_email : candidate[0].email,
            can_mobile : candidate[0].contact_no,
            data : {
                      sender_id: sender_id,
                      candidate_id: this.candidate_id,
                      job_id: this.jobId,
                      mailer_id: mailer_id
                    }
          }
          console.log('Mail data', this.selected[i], mailData)
          let mail = ''
          if(this.attachments) {
            mail = emailTemplates.massMailerToCheckifCandidateInterested(mailData)
            
          } else {
            mail = emailTemplates.massMailerToCheckifCandidateInterested_NOJD(mailData)
          }
          setTimeout(() => {
          if(mail) {
            
                mailService.massMail(mail).then(res => {
                  console.log("in mail Send", res)
                  
                  let data = {}
                  if (res.status === "OK") {
                    
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'Mail Send to candidate Successful',
                        icon: 'MailIcon',
                        variant: 'success',
                        timeout: 3000,
                      }
                    })
                    
                    //mailList.push(data)
                    
                  } else if (res.status === 502) {
                      
                      
                      this.$toast({
                        component: ToastificationContent,
                        props: {
                          title: 'Mail Send to candidate Failed',
                          icon: 'MailIcon',
                          variant: 'danger',
                          timeout: 3000,
                        }
                      })
                      // data = {
                      //   sender_id: sender_id,
                      //   candidate_id: this.candidate_id,
                      //   job_id: this.jobId,
                      //   mail_sent: false,
                      //   response: ''
                      // }
                      // mailList.push(data)
                      
                  } else if ((res.status === 401 ) || (res.status === 403 )) {
                    
                      this.$toast({
                        component: ToastificationContent,
                        props: {
                          title: 'Login Session Expired, Login Again',
                          icon: 'MailIcon',
                          variant: 'danger',
                          timeout: 3000,
                        }
                      })
                      window.sessionStorage.setItem('lastPage', window.location.href.split('/#')[1])
                      // data = {
                      //   sender_id: sender_id,
                      //   candidate_id: this.candidate_id,
                      //   job_id: this.jobId,
                      //   mail_sent: false,
                      //   response: ''
                      // }
                      localStorage.clear();
                      this.$router.push({ name: "auth-login" });
                  } else if (res.status === 500) {
                    
                    this.$toast({
                        component: ToastificationContent,
                        props: {
                          title: 'Some Error occurred' + res.error,
                          icon: 'MailIcon',
                          variant: 'danger',
                        }
                      })
                      // data = {
                      //   sender_id: sender_id,
                      //   candidate_id: this.candidate_id,
                      //   job_id: this.jobId,
                      //   mail_sent: false,
                      //   response: ''
                      // }
                      // mailList.push(data)
                      
                  } else {
                    
                    this.$toast({
                        component: ToastificationContent,
                        props: {
                          title: 'Some Error occurred' + res,
                          icon: 'MailIcon',
                          variant: 'danger',
                        }
                    })
                    // data = {
                    //     sender_id: sender_id,
                    //     candidate_id: this.candidate_id,
                    //     job_id: this.jobId,
                    //     mail_sent: false,
                    //     response: ''
                    //   }
                    //   mailList.push(data)

                    
                  }
                  
                  //console.log(mailList)
                })
           
           //
                
                
                  // if(mailList.length  === (this.selected.length - 1)) {
                  //   console.log('the end')
                  //   console.log('Mass Mail list', mailList)
                  //   //console.table(this.massMailList)
                    
                  //     const d = { data : "'" + JSON.stringify(mailList) + "'" }
                    
                  //   console.log('Mass Mail list',mailList , d)
                  //   massMailerService.createMailer(d).then(res => {
                  //     console.log(res)
                  //     if(res.status === "OK") {
                  //       console.log('mass mail data', res.data)
                  //     }
                  //   })
                  // } else {
                  //   console.log('else', mailList, mailList.length, this.selected.length )
                  // }
                
                console.log('hi', i, Date.now())
            //setTimeout(this.sendMail,1000, mail)
            // setTimeout(() => { this.sendMail() }, 1000);
            // console.log('waiting for 1 sec', new Date())
          
          }
        },i * 1000)
        
        
      }
      // setTimeout(() => {
      //   if(mailList) {
      //     console.log('Mass Mail list', mailList)
      //     //console.table(this.massMailList)
          
      //      const d = { data : "'" + JSON.stringify(mailList) + "'" }
          
      //     console.log('Mass Mail list',mailList , d)
      //     massMailerService.createMailer(d).then(res => {
      //       console.log(res)
      //       if(res.status === "OK") {
      //         console.log('mass mail data', res.data)
      //       }
      //     })
      //   } else {
      //     console.log('else', mailList)
      //   }
      
      
      
      // this.selected = []

    },
    // sendMail() {
    //   mailService.massMail(this.bulkMailData).then(res => {
    //         const userData = JSON.parse(localStorage.getItem("userData"));
    //         const sender_id = `${userData.emp_id}`
    //         console.log("in mail Send", res)
    //         if (res.status === "OK") {
    //           const data = {
    //             sender_id: sender_id,
    //             candidate_id: this.candidate_id,
    //             job_id: this.jobId,
    //             mail_sent: true,
    //             response: ''
    //           }
    //           this.massMailList.push(data)
    //           this.$toast({
    //             component: ToastificationContent,
    //             props: {
    //               title: 'Mail Send to candidate Successful',
    //               icon: 'MailIcon',
    //               variant: 'success',
    //               timeout: 3000,
    //             }
    //           })
              
              
    //         } else if (res.status === 502) {
    //             //this.loading = false
    //             const data = {
    //               sender_id: emp_id,
    //               candidate_id: this.candidate_id,
    //               job_id: this.jobId,
    //               mail_sent: false,
    //               response: ''
    //             }
    //             this.massMailList.push(data)
    //             this.$toast({
    //               component: ToastificationContent,
    //               props: {
    //                 title: 'Mail Send to candidate Failed',
    //                 icon: 'MailIcon',
    //                 variant: 'danger',
    //                 timeout: 3000,
    //               }
    //             })
                
    //         } else if ((res.status === 401 ) || (res.status === 403 )) {
    //           const data = {
    //               sender_id: emp_id,
    //               candidate_id: this.candidate_id,
    //               job_id: this.jobId,
    //               mail_sent: false,
    //               response: ''
    //             }
    //             this.massMailList.push(data)
    //           this.$toast({
    //               component: ToastificationContent,
    //               props: {
    //                 title: 'Login Session Expired, Login Again',
    //                 icon: 'MailIcon',
    //                 variant: 'danger',
    //                 timeout: 3000,
    //               }
    //             })
                
    //             //this.error = 'Seesion Expired. Please Login again'
    //             localStorage.clear();
    //             this.$router.push({ name: "auth-login" });
    //         } else if (res.status === 500) {
    //           const data = {
    //               sender_id: emp_id,
    //               candidate_id: this.candidate_id,
    //               job_id: this.jobId,
    //               mail_sent: false,
    //               response: ''
    //             }
    //             this.massMailList.push(data)
    //           this.$toast({
    //               component: ToastificationContent,
    //               props: {
    //                 title: 'Some Error occurred' + res.error,
    //                 icon: 'MailIcon',
    //                 variant: 'danger',
    //               }
    //             })
                
    //         } else if(!res || res == undefined) {
    //           const data = {
    //               sender_id: emp_id,
    //               candidate_id: this.candidate_id,
    //               job_id: this.jobId,
    //               mail_sent: false,
    //               response: ''
    //             }
    //             this.massMailList.push(data)
    //         } else {
    //           const data = {
    //               sender_id: emp_id,
    //               candidate_id: this.candidate_id,
    //               job_id: this.jobId,
    //               mail_sent: false,
    //               response: ''
    //             }
    //             this.massMailList.push(data)
    //           this.$toast({
    //               component: ToastificationContent,
    //               props: {
    //                 title: 'Some Error occurred' + res,
    //                 icon: 'MailIcon',
    //                 variant: 'danger',
    //               }
    //           })
              
    //         }
    //       })
    // },
    multiAssignToJob() {
      for (var i = 0; i < this.selected.length; i++) {
        this.assignJob(this.selected[i], this.selected[i], 'ATS', 'M')
      }
    },
    numDaysBetween(d1, d2) {
        var diff = Math.abs(d1.getTime() - d2.getTime());
        return diff / (1000 * 60 * 60 * 24);
    },
    // onFiltered(filteredItems) {
    //     // Trigger pagination to update the number of buttons/pages due to filtering
    //     this.totalRows = filteredItems.length
    //     this.currentPage = 1
    // }
  },
  // updated: function () {
  //   this.$nextTick(function () {
  //     // Code that will run only after the
  //     // entire view has been re-rendered
      
  //     const scrollPosition = localStorage.getItem('lastPosition')
  //     console.log('called',JSON.stringify(scrollPosition))
  //     console.log('last position', JSON.parse(scrollPosition).y  )
  //     window.scrollTo(0, JSON.parse(scrollPosition).y);
  //   })
  // },
  updated: function () {
      console.log('called in updated')
      this.$nextTick(function () {
        console.log('called in updated nextTick')
        // Code that will run only after the
        // entire view has been re-rendered
        // let y = null
        const scrollPosition = localStorage.getItem('lastPosition')
        console.log('called in updated nextTick getting localstorage', typeof scrollPosition, scrollPosition)
        if (scrollPosition !== '[object Object]') {
           const y = JSON.parse(scrollPosition).y
           

          setTimeout( () => {
            console.log('called in updated nextTick after settimeout', scrollPosition, y)
            if(y) {
              window.scrollTo(0, y);
            }
          },500);
        }
        
        
      })
    },
  // computed: {
  //   totalRows() {
  //     return this.fetchCandidates.length
  //   }
  // }
  watch: {
    perPage() {
      this.currentPage = 1
    },
  },
  mounted() {
      // Set the initial number of items
      adminConfigService.getATSDropdownList().then(res => {
        if(res.status === 200) {
          this.sourceOptions = res.data.data
          // this.sources = res.data.data.sourceList
          this.qualificationOptions = res.data.data.qualificationList
        }
      })
  },
  /*computed: {
		fetchCandidates () {
      if(this.filter.length > 3) {
			return this.filter
				? this.fetchCandidates.filter(item => item.first_name.includes(this.filter) || 
                                              item.last_name.includes(this.filter) ||
                                              item.email.includes(this.filter) || 
                                              item.contact_no.includes(this.filter) || 
                                              item.locations.includes(this.filter) || 
                                              item.source.includes(this.filter) || 
                                              item.skills.includes(this.filter) ||
                                              item.jobs.length ? item.jobs[0].candidate_jobs.candidateStatus.includes(this.filter) : item.status.includes(this.filter))
				: this.fetchCandidates
      }else {
        return this.fetchCandidates;
      } 
		}
	},*/
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
.scroller {
  height: 100%;
}
/*.vue-recycle-scroller{position:relative}.vue-recycle-scroller.direction-vertical:not(.page-mode){overflow-y:auto}.vue-recycle-scroller.direction-horizontal:not(.page-mode){overflow-x:auto}.vue-recycle-scroller.direction-horizontal{display:-webkit-box;display:-ms-flexbox;display:flex}.vue-recycle-scroller__slot{-webkit-box-flex:1;-ms-flex:auto 0 0px;flex:auto 0 0}.vue-recycle-scroller__item-wrapper{-webkit-box-flex:1;-ms-flex:1;flex:1;-webkit-box-sizing:border-box;box-sizing:border-box;overflow:hidden;position:relative}.vue-recycle-scroller.ready .vue-recycle-scroller__item-view{position:absolute;top:0;left:0;will-change:transform}.vue-recycle-scroller.direction-vertical .vue-recycle-scroller__item-wrapper{width:100%}.vue-recycle-scroller.direction-horizontal .vue-recycle-scroller__item-wrapper{height:100%}.vue-recycle-scroller.ready.direction-vertical .vue-recycle-scroller__item-view{width:100%}.vue-recycle-scroller.ready.direction-horizontal .vue-recycle-scroller__item-view{height:100%}.resize-observer[data-v-b329ee4c]{position:absolute;top:0;left:0;z-index:-1;width:100%;height:100%;border:none;background-color:transparent;pointer-events:none;display:block;overflow:hidden;opacity:0}.resize-observer[data-v-b329ee4c] object{display:block;position:absolute;top:0;left:0;height:100%;width:100%;overflow:hidden;pointer-events:none;z-index:-1}*/
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';



</style>
